module.exports = __webpack_public_path__ + "static/media/happyHour.e05b6cb7.pdf";